import { create } from 'zustand';

export const useCategoryStore = create<{
  categories: Array<any>;
}>(() => ({
  categories: []
}));
